import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";

import Popover from "components/library/Popover";
import Button from "components/library/Button";
import { removeCustomBlock } from "editor/actions/blocks";
import { EDITOR_MODALS } from "config/constants/editor";

import shared from "../../../shared.css";
import styles from "./ImagePopover.css";

class ImagePopover extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSmall: null,
    };

    this.calculateOffset = this._calculateOffset.bind(this);
    this.handleMatchMedia = this._handleMatchMedia.bind(this);
    this.handleOnClick = this._handleOnClick.bind(this);
    this.match = null;
  }

  componentDidMount() {
    this.match = window.matchMedia(shared["breakpoint-small"]);
    this.match.addListener(this.handleMatchMedia);
  }

  componentWillUnmount() {
    this.match.removeListener(this.handleMatchMedia);
  }

  _handleOnClick(e) {
    e.preventDefault();
    this.props.removeCustomBlock(this.props.blockKey);
  }

  _calculateOffset() {
    if (!this.props.imageElement || !this.props.isActive) {
      return;
    }

    let {
      top: imageTop,
      width: imageWidth,
    } = this.props.imageElement.getBoundingClientRect();

    imageTop = `${imageTop / 10}rem`;

    return {
      top: this.state.isSmall
        ? `calc(${imageTop} + ${shared["scale-4"]})`
        : imageTop,
      left: this.state.isSmall
        ? `calc(${(document.documentElement.clientWidth / 2 - imageWidth / 2) /
            10}rem + ${shared["scale-4"]})`
        : `calc(${(document.documentElement.clientWidth / 2 + imageWidth / 2) /
            10}rem + ${shared["scale-6"]})`,
    };
  }

  _handleMatchMedia(e) {
    this.setState({ isSmall: !e.matches });
  }

  isActive() {
    return this.props.isActive && this.props.openModal !== EDITOR_MODALS.LINK;
  }

  render() {
    // TODO: Add the onClick handler to actually delete the image. Will happen after that action gets written.
    const position = this.calculateOffset();

    return (
      <Popover
        isOpened={this.isActive()}
        position={position}
        className={styles.root}
        closeModal={this.props.closeModal}
      >
        <Button
          className={classNames(styles.menuItem, styles.red)}
          destructive
          onClick={this.handleOnClick}
          type="tertiary"
        >
          Delete image
        </Button>
      </Popover>
    );
  }
}

const mapStateToProps = state => {
  return {
    openModal: state.editor.ui.openModal,
  };
};

const mapDispatchToProps = {
  removeCustomBlock,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImagePopover);

ImagePopover.propTypes = {
  blockKey: PropTypes.string.isRequired,
  imageElement: PropTypes.instanceOf(Element),
  closeModal: PropTypes.func.isRequired,
  removeCustomBlock: PropTypes.func.isRequired,
};
